import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "@firebase/auth";
import { auth } from "../utils/firebaseSecondary";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPasssword, setRegisterPassword] = useState("");

  let navigate = useNavigate();

  const register = async () => {
    try {
      const user = await createUserWithEmailAndPassword(
        auth,
        registerEmail,
        registerPasssword
      );
      console.log(user);
      navigate("/");
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="white-box">
        <h1>SignUp</h1>
        <div>
          <input
            className="modal-input"
            placeholder="Email"
            onChange={(e) => {
              setRegisterEmail(e.target.value);
            }}
          />
          <input
            className="modal-input"
            type="password"
            placeholder="Password"
            onChange={(e) => {
              setRegisterPassword(e.target.value);
            }}
          />
        </div>
        <button className="submit-button" onClick={() => register()}>
          Register
        </button>
      </div>
    </div>
  );
};

export default SignUp;
